import { createUrlStripper } from "../urlStripper"
import type { VendorParams } from "./UrlParams"

export const parseAmnBooleanParam = (
  stringValue: string | undefined
): boolean | undefined =>
  stringValue === "1" ? true : stringValue === "0" ? false : undefined

export const parseAmnInitialVolume = (
  stringValue: string | undefined
): number | undefined => {
  if (stringValue === undefined) return undefined
  const parsed = parseFloat(stringValue)
  if (isNaN(parsed) || parsed < 0 || parsed > 1) return undefined
  return Math.round(parsed * 100) // Convert 0-1 range to 0-100 for UCS
}

export const parseAmnParams = (url: string): VendorParams => {
  const urlStripper = createUrlStripper(url)
  const participantName = urlStripper.stripParam("amn.agentName")
  // The interpreter's id is currently unused, but we should strip it off
  const _participantId = urlStripper.stripParam("amn.agentLegId")
  const disableAudioString = urlStripper.stripParam("amn.disableAudio")
  const disableVideoString = urlStripper.stripParam("amn.disableVideo")
  const initialVolumeString = urlStripper.stripParam("amn.initialVolume")
  const disableAudio = parseAmnBooleanParam(disableAudioString)
  const disableVideo = parseAmnBooleanParam(disableVideoString)
  const initialVolume = parseAmnInitialVolume(initialVolumeString)
  const urlWithoutVendorParams = urlStripper.toString()
  return {
    urlWithoutVendorParams,
    participantName,
    startCallOnMute: disableAudio,
    startWithVideo: disableVideo === undefined ? undefined : !disableVideo,
    initialVolume,
  }
}
